module.exports = __webpack_public_path__ + "img/instruction_fullorder_2d_mobile.f65eb2aa.png";